module.exports = __webpack_public_path__ + "static/img/vi.8c9cb3a5.png";